import type { Locale as DateFnsLocale } from 'date-fns';
import { enUS as enLocale, es as esLocale, ru as ruLocale } from 'date-fns/locale';

export function getDateFnsLocale(lang: string): DateFnsLocale {
  switch (lang) {
    case 'ru':
      return ruLocale;
    case 'es':
      return esLocale;
    case 'en':
    default:
      return enLocale;
  }
}
